import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

type HydrationError = {
	type: string;
	msg: string;
	stack?: string;
	parentNode?: HTMLElement;
	parent?: HTMLElement;
	child?: HTMLElement;
};

interface LoggingConfig {
	selectors?: boolean;
	errors?: boolean;
	stack?: boolean;
	stackLength?: number;
}

interface HydrationErrorAccumulator {
	[key: string]: string;
}

const getElementSelector = (element: HTMLElement) => {
	const selector = `${element.tagName.toLowerCase()}.${element.className?.split(' ').join('.')}`;

	if (element.dataset?.testid) {
		return `${selector}[data-testid="${element.dataset?.testid}"]`;
	}

	return selector;
};

export const convertHydrationErrors = (hydrationErrors: HydrationError[]) => {
	let loggingConfig: LoggingConfig = {};
	try {
		loggingConfig = JSON.parse(
			StatsigConfigurations.getString('confluence_hydration_error_logging', '{}'),
		);
	} catch (error) {
		// no-op, if an error occurs here, there's really nowhere to submit it
	}

	return hydrationErrors.reduce((accumulator: HydrationErrorAccumulator, error) => {
		if (!error.type || !error.msg) return accumulator;
		if (!accumulator[error.type]) {
			accumulator[error.type] = '';
		}

		if (!accumulator.selectors) {
			accumulator.selectors = '';
		}

		// Log selectors for mismatched hydration errors. The presense of parentNode or parent
		// depend on actual hydration error / patch used.
		const finalParent = error.parent || error.parentNode;
		if (loggingConfig.selectors && (finalParent || error.child)) {
			const parent = finalParent ? getElementSelector(finalParent) : 'n/a';
			const child = error.child ? getElementSelector(error.child) : 'n/a';

			accumulator.selectors += `${parent}->${child}; `;
		}

		if (loggingConfig.errors) {
			accumulator[error.type] += (accumulator[error.type] ? ' ; ' : '') + error.msg;
		}

		// Add error stack
		if (loggingConfig.stack && error.stack) {
			if (!accumulator.stack) {
				accumulator.stack = '';
			}
			accumulator.stack += `Stack: ${error.stack} \n`;
		}
		return accumulator;
	}, {});
};
